let commonConfig;
try {
  commonConfig = require('./common.json');
}
catch (e) {
  throw new Error('Please define config/common.json file. Exception: ' + e.message);
}

module.exports = {
  apiUrl: commonConfig.apiUrl,
  baseUrl: commonConfig.baseUrl,
  apiCrmAnalyticsUrl: commonConfig.apiCrmAnalyticsUrl,
  apiIdUrl: commonConfig.apiIdUrl,
  siteFpUrl: commonConfig.siteFpUrl,
  apiFpUrl: commonConfig.apiFpUrl,
  siteUnigineUrl: commonConfig.siteUnigineUrl,
  env: commonConfig.env,
};



// WEBPACK FOOTER //
// ./src/config/client.js